export default __webpack_public_path__ + "static/media/CNo.36-3.4fd3a39b.jpg";